<template>
  <div style="width: 100%;" @click="goTo" class="article-item">
    <div class="article">
      <span class="a-title">{{ tRecord.volumeTitleAndArticleTitle }}</span>
      <div class="a-text">
        <div class="row">
          <div class="title">作者:</div>
          <div class="word">{{ tRecord.articleAuthor }}</div>
        </div>
        <div class="row">
          <div class="title">册号:</div>
          <div class="word">{{ tRecord.volumeName }}</div>
        </div>
        <div class="row">
          <div class="title">页码:</div>
          <div class="word">{{ tRecord.page }}</div>
      </div>
      </div>
    </div>
    <div class="border"></div>
  </div>
</template>

<script>
import userActionsApi from '@/api/userActions.js'
import { mapGetters } from 'vuex'
export default {
    data () {
      return {}
    },
    props: {
        record: Object,
        fileNumber: Number,
        bookInfo: Object
    },
    computed: {
      ...mapGetters(['isTra']),
      tRecord () {
         return this.isTra ? JSON.parse(this.record.originInfos) : this.record
      }
    },
    methods: {
      goTo () {
        // 2024年9月26日15:03:27 本系统暂不考虑其他数据，目前存储的用户行为，仅考虑书籍信息
        userActionsApi.addUserAction({
          actionCode: 'resourceRead',
          bookId: this.record.bookId,
          resourceId: this.bookInfo.id,
          resourceInfos: JSON.stringify(this.bookInfo),
          resourceCategory: 'bookMetaData',
          terminalType: this.$isPhone ? 'mobile' : 'pc'
        })

        let url = window.location.origin + window.location.pathname
        window.open(`${url}#/book${this.$isPhone ? '-mobile' : ''}?bookId=${this.record.bookId}&page=${this.record.page}&volumeName=${this.record.volumeName}&fileNumber=${this.fileNumber}`)
      }
    }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.article-item {
  width: 100%;
  padding: 4px 5px;
}
.border {
  width: 100%;
  border-bottom: 1px solid #a6a6a6;
  // margin-top: 12px;
}
.highlight {
  .article {
    background-color: rgba(158, 136, 113, 0.4);
    border-radius: 4px;
  }
}
.article {
  width: 100%;
  cursor: pointer;
  padding-left: 12px;
  .a-title {
    color: #4D4030;
    font-weight: bold;
  }
  .sub-title {
    display: inline-block;
    font-weight: bold;
    color: #7c1823;
    margin-left: 12px;
  }
  .row {
    display: flex;
    .title {
      color: #4d4030;
      min-width: 64px;
    }
    .word {
        margin-left: 12px;
        border-radius: 4px;
        color: #7a7374;
        overflow:hidden; //超出的文本隐藏
        text-overflow:ellipsis; //溢出用省略号显示
        white-space:nowrap; //溢出不换行
        max-width: 670px;
    }
  }
  .a-text {
    // text-indent: 2em;
    // height: 90px;
    margin: 10px;
    white-space: pre-line;
  }
}
// @media screen and (min-width: 769px) {
  .a-title {
    .font-size-medium;
  }
  .sub-title {
    .font-size-small;
  }
  .title {
    .font-size-medium;
  }
// }
// @media screen and (max-width: 768px) {
//   .a-title {
//     font-size: 36px;
//   }
//   .sub-title {
//     font-size: 32px;
//   }
//   .title {
//     font-size: 28px;
//   }
//   .word {
//     font-size: 28px;
//   }
// }
</style>
